<template>
    <h4>Fecha</h4>
</template>

<script>
    export default{
        name: "BlogFecha",
    }
</script>
